"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1176],{

/***/ 6333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LinkPreview_LinkPreview; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../wif-ui-lib/dist/LinkPreview.js
var LinkPreview = __webpack_require__(8041);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/LinkPreview/LinkPreview.tsx







function LinkPreview_LinkPreview(props) {
    var type = props.type;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var cardNodes = (0,magnolia/* jcrMultiFieldToArray */.FE)(type.cards);
    var cards = cardNodes.map(function(node) {
        return mapCardNodeToLinkPreview(node, imageDataHandler);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkPreview/* LinkPreview */.G, {
        hasImages: type.field === "image",
        hasSaveButton: false,
        cards: cards
    });
}
function mapCardNodeToLinkPreview(node, imageDataHandler) {
    var ref;
    var image = node.image, cardTitle = node.cardTitle, cardIntroText = node.cardIntroText, link = node.link, altText = node.altText, linkLabel = node.linkLabel, linkDescription = node.linkDescription;
    if (!image || !altText) {
        return {
            cardTitle: cardTitle,
            cardIntroText: cardIntroText,
            link: link,
            linkLabel: linkLabel,
            linkDescription: linkDescription
        };
    }
    var imageProps = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageDataHandler(image, {
        maxViewport: app/* Viewport.xs */.l_.xs
    })), {
        altText: altText,
        credits: image === null || image === void 0 ? void 0 : (ref = image.metadata) === null || ref === void 0 ? void 0 : ref.rights
    });
    return {
        imageProps: imageProps,
        cardTitle: cardTitle,
        cardIntroText: cardIntroText,
        link: link,
        linkLabel: linkLabel,
        linkDescription: linkDescription
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/LinkPreview/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 8041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ at; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8643);
/* harmony import */ var _LinkPreviewCard_2daafeaa_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4382);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4877);
/* harmony import */ var _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7977);













const H = "lp-container--bg-auto", D = "lp-container__employer", G = "lp-container__content", W = "desktop", j = "lp-container__content-no-images", q = "lp-container", z = "button-container", t = {
  lpContainerBgAuto: H,
  lpContainerEmployer: D,
  lpContainerContent: G,
  desktop: W,
  lpContainerContentNoImages: j,
  lpContainer: q,
  buttonContainer: z
}, F = 5;
function at(c) {
  const {
    cards: n,
    hasImages: e,
    hasSaveButton: p,
    newTab: m,
    backgroundColor: C = "auto",
    ...d
  } = c, [r, u] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(3), g = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_1__.u)();
  if (!n.length)
    return null;
  const b = () => {
    r >= n.length || u((i) => i + F);
  }, S = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
    t.lpContainerContent,
    e ? "" : t.lpContainerContentNoImages
  ), h = n.slice(0, r), k = e ? n : h;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__.B,
    {
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__.B.Padding.NONE,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__.B.Padding.LARGE,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
        t.lpContainer,
        g && t.lpContainerEmployer,
        C === "auto" && t.lpContainerBgAuto
      ),
      ...d
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_3__.B.Content, { className: S }, k.map((i, E) => {
      const {
        cardIntroText: w,
        cardTitle: B,
        imageProps: T,
        link: s,
        linkLabel: f,
        linkLocale: N,
        linkDescription: _,
        isSaved: v,
        onSave: y,
        showCTAOnMobile: P,
        newTab: I,
        hasSaveButton: L,
        badge: A
      } = i;
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _LinkPreviewCard_2daafeaa_mjs__WEBPACK_IMPORTED_MODULE_4__.L,
        {
          key: s + E,
          cardIntroText: w,
          cardTitle: B,
          imageProps: T,
          link: s,
          linkDescription: _,
          linkLocale: N,
          hasImages: e,
          hasSaveButton: L || p,
          linkLabel: f,
          isSaved: v,
          onSave: y,
          newTab: I || m,
          showCTAOnMobile: P,
          badge: A
        }
      );
    })),
    !e && r < n.length && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: t.buttonContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.Secondary,
      {
        text: "Show more",
        onClick: b
      },
      "show more"
    ))
  );
}

//# sourceMappingURL=LinkPreview.js.map


/***/ }),

/***/ 4382:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Y; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5905);
/* harmony import */ var _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965);
/* harmony import */ var _CallToAction_d24a74ed_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1416);





const N = "link-preview-card", L = "desktop", T = "image-container", S = "image", B = "badge", x = "link-wrapper", E = "preview-container", W = "preview-content", P = "card-title", f = "card-intro-text", y = "preview-link", H = "cta-hover", A = "save-button-container", M = "cta", O = "no-images-card", _ = "no-images-preview-content", R = "no-images-card-link-wrapper", D = "no-save-no-images-button-card-height", V = "no-save-button-card-link-wrapper", j = "no-save-no-images-link-wrapper", q = "no-save-button-preview-content", z = "no-save-button-cta", F = "hide-cta-on-mobile", e = {
  linkPreviewCard: N,
  desktop: L,
  imageContainer: T,
  image: S,
  badge: B,
  linkWrapper: x,
  previewContainer: E,
  previewContent: W,
  cardTitle: P,
  cardIntroText: f,
  previewLink: y,
  ctaHover: H,
  saveButtonContainer: A,
  cta: M,
  noImagesCard: O,
  noImagesPreviewContent: _,
  noImagesCardLinkWrapper: R,
  noSaveNoImagesButtonCardHeight: D,
  noSaveButtonCardLinkWrapper: V,
  noSaveNoImagesLinkWrapper: j,
  noSaveButtonPreviewContent: q,
  noSaveButtonCta: z,
  hideCtaOnMobile: F
};
function Y(l) {
  const {
    cardTitle: i,
    cardIntroText: d,
    link: m,
    linkLabel: s,
    linkLocale: p,
    imageProps: a,
    hasImages: n,
    hasSaveButton: r,
    showCTAOnMobile: v = !0,
    newTab: c = !0,
    badge: C
  } = l, k = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.linkPreviewCard, {
    [e.noImagesCard]: !n,
    [e.noSaveNoImagesButtonCardHeight]: !r && !n,
    [e.hideCtaOnMobile]: !v
  }), w = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.linkWrapper, {
    [e.noImagesCardLinkWrapper]: !n,
    [e.noSaveButtonCardLinkWrapper]: !r,
    [e.noSaveNoImagesLinkWrapper]: !n && !r
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: k, "data-testid": "link-preview-container" }, n && a && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.imageContainer }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_2__.I,
    {
      credits: a.credits,
      src: a.src,
      width: a.width,
      height: a.height,
      altText: a.altText,
      imageLoader: a.imageLoader,
      className: e.image,
      styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_2__.a.PREVIEW_CARD,
      "data-testid": "link-preview-image"
    }
  ), C && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.badge, "data-testid": "link-preview-badge" }, C)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: w }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_3__.L,
    {
      href: m,
      locale: p,
      "aria-label": i,
      disableLinkTextStyle: !0,
      className: e.previewLink,
      target: c ? "_blank" : void 0,
      "data-testid": "link-preview-link"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.previewContainer, "aria-hidden": "true" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      G,
      {
        cardIntroText: d,
        cardTitle: i,
        linkLabel: s,
        hasImages: n,
        hasSaveButton: r,
        newTab: c
      }
    ))
  )));
}
const G = (l) => {
  const { cardIntroText: i, cardTitle: d, hasImages: m, hasSaveButton: s, linkLabel: p, newTab: a } = l, n = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e.previewContent, {
    [e.noImagesPreviewContent]: !m,
    [e.noSaveButtonPreviewContent]: !s
  }), r = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsComponentTitleBold,
    e.cardTitle
  ), v = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsBodyText,
    e.cardIntroText
  ), c = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(
    e.cta,
    e.ctaHover,
    s ? "" : e.noSaveButtonCta
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: n, "data-testid": "link-preview" }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3", { className: r }, d), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: v }, i), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _CallToAction_d24a74ed_mjs__WEBPACK_IMPORTED_MODULE_4__.C,
    {
      containerClassName: c,
      as: "div",
      text: p,
      showCTAIcon: a
    }
  ));
};

//# sourceMappingURL=LinkPreviewCard-2daafeaa.mjs.map


/***/ })

}]);